import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const usages = {
  state: () => ({
    items: [],
    limits:[],
    timeout: null,
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setLimits(state, payload) {
      state.limits = payload.items;
    },
    setUsages(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedUsages(state, payload) {
      state.selectedItems = payload;
    },
    setUsagePage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getUsages");
    },
    setUsageTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getUsages");
    },
  },
  actions: {
    async getUsages(store) {
      store.state.loading = true;
      clearTimeout(store.state.timeout);
      store.state.timeout = null;
      store.state.timeout = setTimeout(async () => {

        await axios
          .post("event/loadrights", {})
          .then((res) => {
            store.state.loading = false;
            return store.commit("setLimits", res.data.data);
          });

        await axios
          .post("organization/loadusagesummary", {
            ...store.state.filter,
            skip: (store.state.filter.page - 1) * store.state.filter.take,
          })
          .then((res) => {
            store.state.loading = false;
            return store.commit("setUsages", res.data.data);
          });

      }, 25);
    },
    async toggleUsage(store, payload) {
      var res = await axios.post("questionlibrary/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteUsage(store, payload) {
      await axios
        .post("questionlibrary/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setUsages", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default usages;



// WEBPACK FOOTER //
// ./src/store/usages.js